import { Action } from '@ngrx/store';
import { OrderULResponse } from '@cemex-core/cmx-api';

export enum SimulateULActionTypes {
  LOAD = '[Rms Simulate UL] Load simulate ul',
  LOAD_COMPLETE = '[Rms Simulate UL] Load complete simulate ul',
  RESET = '[Rms Simulate UL] Reset',
}

export class SimulateULLoadAction implements Action {
  readonly type = SimulateULActionTypes.LOAD;

  constructor() {}
}

export class SimulateULLoadCompleteAction implements Action {
  readonly type = SimulateULActionTypes.LOAD_COMPLETE;

  constructor(public payload: OrderULResponse) {}
}

export class SimulateULResetAction implements Action {
  readonly type = SimulateULActionTypes.RESET;

  constructor() {}
}

export type SimulateULActions = SimulateULLoadAction | SimulateULLoadCompleteAction | SimulateULResetAction;
